import { render, staticRenderFns } from "./showMore.vue?vue&type=template&id=50a9ea00&scoped=true"
import script from "./showMore.vue?vue&type=script&lang=js"
export * from "./showMore.vue?vue&type=script&lang=js"
import style0 from "./showMore.vue?vue&type=style&index=0&id=50a9ea00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a9ea00",
  null
  
)

export default component.exports